// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"210":"people","242":"project","438":"forecast","702":"settings-settings","928":"accounts-accounts","966":"dashboard","973":"edit-profile"}[chunkId] + "." + {"210":"15d51c19e5","242":"f617a7ee6c","438":"ac4db4ea76","702":"81ddec6ad5","928":"60df40c55c","966":"9688c095e8","973":"4e968ff6c4"}[chunkId] + ".chunk.js";
};